<template>

</template>
<script>
export default {
  data(){
    return {

    }
  },
  mounted() {
    wx.config({
      beta: true,// 必须这么写，否则wx.invoke调用形式的jsapi会有问题
      debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: 'ww1ae80eccc8c19cbe', // 必填，企业微信的corpID
      timestamp:'', // 必填，生成签名的时间戳
      nonceStr: '', // 必填，生成签名的随机串
      signature: '',// 必填，签名，见 附录-JS-SDK使用权限签名算法
      jsApiList: ['getLocation'] // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    });
    alert(1);
    wx.getLocation({
      type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
      success: function (res) {
        let latitude = res.latitude; // 纬度，浮点数，范围为90 ~ -90
        let longitude = res.longitude; // 经度，浮点数，范围为180 ~ -180。
        let speed = res.speed; // 速度，以米/每秒计
        let accuracy = res.accuracy; // 位置精度
        alert(latitude);
        alert(longitude);
        alert(speed);
        alert(accuracy);
      },
      error:function (res){
        alert(2);
      }
    });

  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ClockIn.vue